import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import compose from 'lodash/fp/compose';
import styled from 'styled-components';
import { Icon, Button, Divider, Segment } from 'semantic-ui-react';
import { useForm } from 'hooks/useForm';
import {
  // addOrganisation,
  updateOrgFunctionAssignment,
  // addBulkOrgFunctionAssignment,
  addBulkBankBic,
  // addOrgFunctionProposal,
  addBulkOrgFunctionProposal,
} from 'actions';
import { useSchoolType } from 'hooks/useSchoolType';
import { isEmptyValue } from 'components/utils';
import {
  withOrganisation,
  withCountry,
  withTranslation,
  withLegalForm,
  withState,
  withCity,
  withOrganisationFunction,
  withReligion,
  withPublicRespArea,
  withOrganisationMotivation,
  withCurrency,
  withIndustryType,
  withOrgFunctionAssignment,
  // withDependentField,
  withCustomRouter,
  withUserPreferences,
  withLanguage,
  // withOrganisationFunctionProposal,
  withMsgInfo,
} from 'components/hoc';
import {
  // FormModal,
  Input,
  Select,
  FlashMessage,
  // Form,
  ButtonLink,
  OrgForm,
  NewEntriesSelect,
} from 'components/common/FormItems';
import axios from '../../../../../../axios';
import API from '../../../../../../actions/api';
import Swal from 'sweetalert2';
import { RESPONSE_STRINGS } from 'constants/index';
import { getResError } from '../../../../../../actions/account';
// import { setMsgInfo } from 'actions';

const FlexReverse = styled.div`
  display: flex;
  justify-content: right;
`;
const Wrapper = styled.div``;

const StyledButtonLink = styled(ButtonLink)`
  span {
    text-transform: uppercase;
  }
`;

const StyledSegment = styled(Segment)`
  background: var(--admincat-color-grey-1) !important;
  border: 1px solid var(--admincat-color-grey-5) !important;
  color: var(--admincat-color-grey-12) !important;
`;

const orgFormSchema = {
  name: 'required|min:3',
  org_country: 'required',
  // register_institute: 'required',
  no_of_employees: 'numeric',
  revenue_approx: 'numeric',
  website: 'url',
  // public_resp_area: [{ required_if: ['public', 'true'] }],
};

export const customValidationMessage = {
  'min.name': 'Organisation name must be at least 3 characters',
  'required.name': 'Organisation name is required',
  'required.org_country': 'Organisation country is required',
  // 'required_if.public_resp_area': '',
};

const initialValues = {
  name: '',
  org_country: '',
  state: '',
  legal_form: '',
  register_institute: '',
  register_no: '',
  organisation_category: '',
  legal_personality: true,
  public: false,
  non_profit: false,
  org_function_assignment_list: [{}],
};

const OrgFunctionAssignmentForm = (props) => {
  const {
    religionLocaleOptions,
    basePath,
    getOrgById,
    orgFunctionAssignment: { register_institute_options },
    userPreferences,
    activeLanguageOptions,
    tr,
    setMsgInfo,
  } = props;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const { schoolOptionTypes } = useSchoolType();
  const [selectedOrganisation, setSelectedOrganisation] = useState({});
  // const [formSubmitting, setFormSubmitting] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  const [entrySubmitting, setEntrySubmitting] = useState(false);
  const [showEntryForm, setShowEntryForm] = useState(false);
  const [entryValues, setEntryValues] = useState({
    value: '',
    language: userPreferences.language,
  });

  const navigate = useNavigate();
  

  const { q: orgId } = props.routeQueries;

  const onSubmit = async () => {
    try {
      const { id } = props.routeParams;
      if (id) {
        const payload =
          values.org_function_assignment_list.length > 0
            ? values.org_function_assignment_list[0]
            : {};
        await dispatch(updateOrgFunctionAssignment(id, payload));
        dispatch(
          setMsgInfo({
            success: true,
            msg: [`${tr('Org Function proposal updated successfully')}`],
            navigationCounter: 1,
          }),
        );
        return;
      }

      await dispatch(
        addBulkOrgFunctionProposal({
          org_function_assignment_list: values.org_function_assignment_list
            .map(
              ({ BIC, organisation_function, school_type, religion, ...rest }) => ({
                ...rest,
                organisation_id: orgId,
                organisation_function,
                ...(organisation_function === 'school' ? { school_type } : {}),
                ...(organisation_function === 'religious_inst' ? { religion } : {}),
              }),
            )
            .filter(
              ({ organisation_function }) => !isEmptyValue(organisation_function),
            ),
        }),
      );
      dispatch(
        setMsgInfo({
          success: true,
          msg: [`${tr('Org Function proposal added successfully')}`],
          navigationCounter: 1,
        }),
      );

      const bank_bic_list = values.org_function_assignment_list
        .filter(({ organisation_function }) => {
          return organisation_function === 'bank';
        })
        .map(({ organisation_function, ...rest }) => ({ ...rest, org: orgId }));

      if (bank_bic_list.length) {
        await dispatch(addBulkBankBic({ bank_bic_list }));
      }

      setLoading(false);
    } catch (err) {
      setError('Problem creating organisation, please try again');
      setLoading(false);
    }
    navigate(`/dashboard/data/base/org_func_assign?q=${orgId}`);
    window.scrollTo(0, 0);
    // window.location.reload()

  };

  const [orgFunctionAssigError, setOrgFunctionAssigError] = useState('');
  const [owner, setOwner] = useState(false);
  const { handleSubmit, values, errors, touched, handleBlur, handleChange } =
    useForm({
      initialValues,
      validationSchema: orgFormSchema,
      customValidationMessage,
      onSubmit,
    });

  const onChange = (e, index) => {
    const { name, value } = e.target;
    const l_values = [...values.org_function_assignment_list];
    const valueIndex = {
      ...l_values[index],
      [name]: value,
    };
    l_values[index] = valueIndex;
    handleChange({
      target: {
        name: 'org_function_assignment_list',
        value: l_values,
      },
    });
  };


  const toggleEntryField = () => {
    setShowEntryForm(!showEntryForm);
  };

  const onEntryChange = (e) => {
    const { value, name } = e.target;
    setEntryValues({ ...entryValues, [name]: value });
  };

  const validateAndSubmitEntry = async () => {
    if (!(entryValues.name && entryValues.language)) {
      Swal.fire(
        tr('Warning!'),
        tr(`Please ensure all required fields are populated.`),
        'warning',
      );
      return;
    }
    try {
      setEntrySubmitting(true);
      const payload = {
        name: entryValues.name,
        language: entryValues.language,
        entry_type: 'org_function_proposal',
      };
      await axios.post(`${API}/propose/entry/`, payload);
      Swal.fire(
        tr('Success!'),
        tr(`${RESPONSE_STRINGS?.ENTRY_RESPONSE_SUCCESS_MESSAGE}`),
        'success',
      );
      setEntryValues({});
      setEntrySubmitting(false);
      setShowEntryForm(false);
      return;
    } catch (error) {
      const err = getResError(error);
      dispatch(setMsgInfo({ success: false, msg: err }));
      setEntrySubmitting(false);
      setShowEntryForm(false);
    } finally {
      setEntrySubmitting(false);
      setShowEntryForm(false);
    }
  };


  const remove = (index) => {
    const l_values = [...values.org_function_assignment_list];
    if (l_values.length > 1) {
      l_values.splice(index, 1);
      handleChange({
        target: {
          name: 'org_function_assignment_list',
          value: l_values,
        },
      });
    }
  };

  const add = () => {
    const lastValues =
      values.org_function_assignment_list[
        values.org_function_assignment_list.length - 1
      ];
    const organisation_function = lastValues['organisation_function'];
    const school_type = lastValues['school_type'];
    const religion = lastValues['religion'];
    if (!organisation_function) return;
    if (organisation_function === 'school_type' && !school_type) return;
    if (organisation_function === 'religious_inst' && !religion) return;
    orgFunctionAssigError && setOrgFunctionAssigError('');
    handleChange({
      target: {
        name: 'org_function_assignment_list',
        value: [...values.org_function_assignment_list, {}],
      },
    });
  };

  const addBIC = () => {
    // const lastValues = org_function_assignment_list[
    //   org_function_assignment_list.length - 1
    // ]

    orgFunctionAssigError && setOrgFunctionAssigError('');

    handleChange({
      target: {
        name: 'org_function_assignment_list',
        // value: [...org_function_assignment_list,  {}]
        value: [...[], {}],
      },
    });
  };

  const toggleForm = () => {
    const { name, organisation_function, school_type, religion, BIC } =
      values.org_function_assignment_list[
        values.org_function_assignment_list.length - 1
      ];
    if (!organisation_function) {
      setOrgFunctionAssigError(tr(`Organization function is required`));
      return;
    }

    if (organisation_function === 'school' && !school_type) {
      setOrgFunctionAssigError(tr(`School type is required`));
      return;
    }

    if (organisation_function === 'religious_inst' && !religion) {
      setOrgFunctionAssigError(tr(`Religion is required`));
      return;
    }

    if (organisation_function === 'bank' && !BIC) {
      setOrgFunctionAssigError(tr(`BIC is required`));
      return;
    }

    setOrgFunctionAssigError('');
    //toggleOrgFuncForm();
    onSubmit();
  };

  React.useEffect(() => {
    const { id } = props.routeParams;

    if (id) {
      try {
        setLoading(true);
        axios
          .get(`${API}/organisation-function-assignment/${id}/org_detail/`)
          .then((response) => {
            const { data } = response;
            setOwner(data?.owner);
            handleChange({
              target: {
                name: 'org_function_assignment_list',
                value: [data],
              },
            });
            setLoading(false);
          })
          .catch((e) => {
            setLoading(false);
          });
      } catch (e) {
        setLoading(false);
      }
    }

    const { q: organisationId } = props.routeQueries;
    const org = getOrgById(organisationId);
    setSelectedOrganisation(org);
  }, []);


  React.useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <Wrapper className="form-wrapper">
      <div className="flex">
          <StyledButtonLink
                to={`${basePath}?q=${props.routeQueries.q}`}
                className="option-btn"
                icon="angle double left"
                name="All Entries"
          />
      </div>
      <div className="row">
      <div
        className="col-7 ml-10 mt-30 container"
        style={{
          position: 'relative',
          background: 'var(--admincat-color-grey-1)',
        }}
      >
      <br/>

          <OrgForm
            isLoading={loading}
            loadingData={formLoading}
            title="Organization Function Assignment"
            onSubmit={() => null}
            renderActionButtons={() => null}
            updateMode={false}
            detailMode={false}
            allowUpdate={owner}
          >
            <Input
              placeholder="Organisation"
              label="Organisation"
              value={selectedOrganisation?.name}
              name="organisation_id"
              id="organisation"
              onChange={handleChange}
              disabled
            />
            {values.org_function_assignment_list.map((values, index) => (
              <StyledSegment key={index}>
                <FlexReverse>
                  <Icon name="cancel" onClick={() => remove(index)} />
                </FlexReverse>
                

            <NewEntriesSelect
              value={values.organisation_function || ''}
              name="organisation_function"
              label="Organization Function"
              optionDefaultValue={tr('Choose Organization Function')}
              localeOptions={props.orgFunctionLocaleOptions}
              onChange={(e) => {
                if (e.target.value === 'proposeValue') {
                  toggleEntryField();
                  return;
                } else {
                  onChange(e, index);
                }
              }}
              entryDefaultLanguage={entryValues.language}
              entryValue={entryValues.name}
              entryLanguageValue={entryValues.language}
              entryValueName={'name'}
              entryType={tr('Organization Function')}
              entryLanguageName={'language'}
              onEntryChange={onEntryChange}
              onCreateNewEntry={(e) => {
                e.preventDefault();
                validateAndSubmitEntry();
              }}
              add={showEntryForm}
              toggleEntryField={toggleEntryField}
              options={activeLanguageOptions}
              isLoading={entrySubmitting}
              closeEntryForm={() => {
                toggleEntryField();
              }}
            />

                {values.organisation_function === 'school' && (
                  <Select
                    optionDefaultValue="Choose School Type"
                    label=" School Type"
                    value={values.school_type || ''}
                    name="school_type"
                    id="school_type"
                    localeOptions={schoolOptionTypes}
                    onChange={(e) => onChange(e, index)}
                    required
                    sort={false}
                  />
                )}
                {values.organisation_function === 'religious_inst' && (
                  <Select
                    optionDefaultValue="Choose Religion"
                    label="Religion"
                    value={values.religion || ''}
                    name="religion"
                    id="religion"
                    localeOptions={religionLocaleOptions}
                    onChange={(e) => onChange(e, index)}
                    required
                    sort={false}
                  />
                )}
             

                {values.organisation_function === 'bank' && (
                  <div>
                    {Array.isArray(values.BIC) ? (
                      values.BIC.map((bic, bicIndex) => (
                        <Input
                          key={bicIndex}
                          placeholder="BIC"
                          label={`BIC ${bicIndex + 1}`}
                          value={bic || ''}
                          name="BIC"
                          id={`BIC-${bicIndex}`}
                          onChange={(e) => onChange(e, index)}
                          required
                        />
                      ))
                    ) : (
                      <Input
                        placeholder="BIC"
                        label={`BIC ${index + 1}`}
                        value={values.BIC || ''}
                        name="BIC"
                        id="BIC"
                        onChange={(e) => onChange(e, index)}
                        required
                      />
                    )}
                    <Button onClick={addBIC} icon="plus" type="button" />
                  </div>
                )}
              </StyledSegment>
            ))}
            <Button onClick={add} icon="plus" type="button" />

            <Button onClick={toggleForm} type="button" isLoading={loading}>
              {props.tr('Save')}
            </Button>

            <Divider />
            {orgFunctionAssigError && (
              <FlashMessage hasError={orgFunctionAssigError}>
                {orgFunctionAssigError}
              </FlashMessage>
            )}
          </OrgForm>
        </div>
      </div>
    </Wrapper>
  );
};

export default compose(
  withCountry,
  withState,
  withCity,
  withLegalForm,
  withIndustryType,
  withOrganisation,
  withOrganisationMotivation,
  withPublicRespArea,
  withOrgFunctionAssignment,
  withOrganisationFunction,
  withCurrency,
  withReligion,
  withTranslation,
  withCustomRouter,
  withUserPreferences,
  withLanguage,
  withMsgInfo,
  // withOrganisationFunctionProposal,
)(OrgFunctionAssignmentForm);
